import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  useToast,
} from "@chakra-ui/react";
import ChecklistForm from "./ChecklistForm";
import axios from "axios";

const ChecklistModal = ({ isOpen, onClose, activeChecklist, job, setAssignedChecklists }) => {
  const toast = useToast();

  if (!activeChecklist) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose} size='xl' scrollBehavior='inside'>
      <ModalOverlay />
      <ModalContent maxH='90vh'>
        <ModalHeader>Complete Checklist</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ChecklistForm
            checklist={activeChecklist}
            onSubmit={async (responses) => {
              try {
                await axios.put(`/api/checklists/${activeChecklist._id}/responses`, { responses });
                toast({
                  title: "Success",
                  description: "Checklist responses saved successfully",
                  status: "success",
                  duration: 3000,
                });
                onClose();
                // Refresh assigned checklists
                const { data } = await axios.get(`/api/checklists/job/${job.JOB_NO}`);
                setAssignedChecklists(data.checklists || []);
              } catch (error) {
                toast({
                  title: "Error",
                  description: "Failed to save responses",
                  status: "error",
                  duration: 3000,
                });
              }
            }}
            onCancel={onClose}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ChecklistModal;
